import { render, staticRenderFns } from "./Header2.vue?vue&type=template&id=38cc6d2f&scoped=true"
import script from "./Header2.vue?vue&type=script&lang=ts"
export * from "./Header2.vue?vue&type=script&lang=ts"
import style0 from "./Header2.vue?vue&type=style&index=0&id=38cc6d2f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38cc6d2f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow})
